export interface Forecast {
	id: number;
	datetime: string;
}

export interface ForecastModel {
	id: number;
	version: string;
}

export interface Prediction {
	id: number;
	version: string;
}

export interface ForecastDetail extends Forecast {
	ensemble_models: ForecastModel[];
	predictions: Prediction[];
	horizont: number;
	granularity: string;
	target: string;
	model: ForecastModel;
	ensemble_version?: string;
}

export interface ForecastCurrentModel {
	ensemble_models: ForecastModel[];
	version: string;
	target: string;
}

export interface TimeseriesData {
	name: string;
	description: string;
	date: string;
	value: number;
}

interface TrendHistoryRow {
	actual_trend: string;
	forecasted_trend: string;
	status: string;
	safety_margin: number | null;
	absolute_error: number | null;
	model_label: string;
}

interface TrendInfo {
	shift: number;
	trend: string;
	precision: number;
	recall_label: string;
	history: Record<string, TrendHistoryRow>;
	bound_lower: number;
	bound_upper: number;
	price: number;
	confidence: number;
}

interface HistoricalEvaluationRow {
	model: string;
	shift: number;
	n: number;
	precision: number;
	recall: number;
	mae: number;
}

interface HistoricalEvaluation {
	period_start: string;
	period_end: string;
	as_of: string;
	rows: HistoricalEvaluationRow[];
}

export interface ForecastData {
	date_forecast: string;
	date_horizon_start: string;
	date_horizon_end: string;
	market_model_label?: string;
	source_states: DataState[];
	table: any[];
	plot: string;
	safety_margin: number;
	safety_margins?: Record<number, number>;
	safety_margin_label?: string;
	currency?: string;
	title: string;
	forecast: ForecastDetail;
	trend_info: TrendInfo[];
	trend_dates: string[];
	historical_evaluation?: HistoricalEvaluation | null;
	mood?: Mood;
}

export interface DataState {
	source: string;
	date: string;
}

export interface DataSource {
	name: string;
	date: string;
}

export enum MoodState {
	POSITIVE = "positive",
	NEUTRAL = "neutral",
	NEGATIVE = "negative"
}

export interface Mood {
	value: MoodState;
}

export interface IndexPoint {
	date: string;
	value: number;
}

export interface MarketIndexSeries {
	name: string;
	description?: string;
	latest_date?: string | null;
	latest_value?: number | null;
	change_1w_pct?: number | null;
	change_1m_pct?: number | null;
	points: IndexPoint[];
}
